export default __webpack_public_path__ + "static/media/ul_figuralny.6e2691b7.svg";